Object.defineProperty(exports, "__esModule", { value: true });
function validateRequestOptions(requestOptions) {
    const { data } = requestOptions;
    const dataIsObject = data instanceof Object;
    const dataIsArray = data instanceof Array;
    if (data != null && (!dataIsObject || dataIsArray)) {
        throw new Error("[makeRequest] 'data' must be an object with keys and values");
    }
}
exports.default = validateRequestOptions;
//# sourceMappingURL=validateRequestOptions.js.map